module.exports = __webpack_public_path__ + "static/img/a004.a6a69c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a004.jpg
// module id = 5UCs
// module chunks = 0